module.exports = __webpack_public_path__ + "static/media/mountain.48e52527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/mountain.png
// module id = 733
// module chunks = 0